import { render, staticRenderFns } from "./blog.vue?vue&type=template&id=4ff3dc5e&scoped=true&"
import script from "./blog.vue?vue&type=script&lang=js&"
export * from "./blog.vue?vue&type=script&lang=js&"
import style0 from "./blog.vue?vue&type=style&index=0&id=4ff3dc5e&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff3dc5e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/app/components/Header.vue').default,NetworkForm: require('/app/components/NetworkForm.vue').default,Button: require('/app/components/Button.vue').default,NewsletterForm: require('/app/components/NewsletterForm.vue').default,FooterV2: require('/app/components/FooterV2.vue').default})
